import { LitElement, html, css, unsafeCSS } from 'lit';
import { grid } from '../../utilities/styles';
import { downArrow } from '../../utilities/icons';
import { EventManager } from '../../utilities/events';
export class AllInLoginLogout extends LitElement {
    static properties = {
        loggedIn: { type: Boolean },
        userName: { type: String },
        greeting: { type: String },
        _isMenuOpen: { state: true },
    };
    constructor() {
        super();
        this._isMenuOpen = false;
        this.greeting = 'Hi';
        this._isMenuOpen = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
        this.eventManager.listen('allin-login', this._onLogin);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }
    _onLogin = (e) => {
        if (e.detail.loggedIn) {
            this.loggedIn = true;
            this.userName = e.detail.name;
        }
        else {
            this.loggedIn = false;
        }
    };
    get _menu() {
        return this.renderRoot.querySelector('#menu');
    }
    get _toggle() {
        return this.renderRoot.querySelector('button');
    }
    get _parentDocument() {
        //return this.renderRoot.host.closest('body');
        return document;
    }
    // New getters to help close account menu button when tabbing on the last item
    get _focusableMenuItems() {
        const assigned = this._menuSlot
            ?.assignedElements({ flatten: true }) ?? [];
        return assigned.flatMap(el => el.matches('a, button, [tabindex]:not([tabindex="-1"])')
            ? [el]
            : Array.from(el.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])')));
    }
    get _lastMenuItem() {
        const items = this._focusableMenuItems;
        return items[items.length - 1];
    }
    get _menuSlot() {
        return this.renderRoot.querySelector('slot[name="menu-items"]');
    }
    render() {
        let markup;
        if (this.loggedIn) {
            markup = html `\n                <button @click=${this._toggleMenu} aria-controls="menu" aria-expanded=${this._isMenuOpen} aria-haspopup="menu" aria-label="${this.greeting}, open account menu">${this.greeting}</button>\n                <p class="mobile_only">${this.greeting}</p>\n                <ul id="menu" class="${this._isMenuOpen ? 'open' : ''}" >\n                    <slot name="menu-items"></slot>\n                </ul>\n            `;
        }
        else {
            markup = html `\n                <slot name="loginlink"></slot>\n            `;
        }
        return html ` \n        <div class="flex gap center widget-container">\n            <slot></slot>\n            ${markup}\n        </div>\n        `;
    }
    _toggleMenu = (e) => {
        //e.preventDefault();
        this._isMenuOpen = !this._isMenuOpen;
        if (this._isMenuOpen) {
            setTimeout(() => {
                //this._parentDocument.addEventListener( 'click', this._closeOnClickOff );
                const firstItem = this._menu.querySelector('a, button');
                firstItem?.focus();
            }, 0);
            this._parentDocument.addEventListener('click', this._closeOnClickOff);
            this._menu.addEventListener('keydown', this._onMenuKeydown);
            //this._menu.addEventListener('focusout',this._closeMenu);
        }
        else {
            this._parentDocument.removeEventListener('click', this._closeOnClickOff);
            this._menu.removeEventListener('keydown', this._onMenuKeydown);
            //this._menu.removeEventListener('focusout',this._closeMenu);
        }
    };
    // _closeMenu = (e)=>{          
    //     if(e.key && e.key == "Escape" || e.relatedTarget && !e.relatedTarget.closest('#menu') ){
    //         e.preventDefault();
    //         this._toggle.focus();
    //         this._isMenuOpen = false;
    //     }
    // }
    // NEW closeMenu for keyboard users
    _onMenuKeydown = (e) => {
        // ESC closes menu
        if (e.key === 'Escape') {
            e.preventDefault();
            this._isMenuOpen = false;
            this._toggle.focus();
            return;
        }
        // TAB on last item closes menu and returns focus
        if (e.key === 'Tab' && !e.shiftKey && e.target === this._lastMenuItem) {
            e.preventDefault();
            this._isMenuOpen = false;
            this._toggle.focus();
        }
    };
    _closeOnClickOff = (e) => {
        //const isClickInside = this._menu.contains( e.target );
        const path = e.composedPath();
        const isClickInside = path.includes(this._menu) || path.includes(this._toggle);
        if (!isClickInside) {
            this._isMenuOpen = false;
            this._parentDocument.removeEventListener('click', this._closeOnClickOff);
        }
    };
    static styles = [
        grid,
        css `
        :host {
            font-family:var(--allin-font-family,inherit);
            font-size:var(--allin-font-size,1rem);
            color:var(--allin-text-color,#fff);
            background-color:var(--allin-bg-color,transparent);
            padding:var(--allin-padding,0);
        }
        button,::slotted(a){
            text-decoration:none;
            border:none;
            color:var(--allin-button-color,#fff);
            background-color:var(--allin-button-bg,transparent);
            font-family:var(--allin-font-family,inherit);
        }
        button{
            display:none;
            position:relative;
            cursor:pointer;
            font-size:var(--allin-font-size,1rem);
        }
        button::after{
            content:"";
            position:absolute;
            right:0;
            top:50%;
            transform:translateY(-50%);
            width:1rem;
            height:0.5rem;
            background-image:url("data:image/svg+xml;charset=UTF-8,<svg xmlns='http://www.w3.org/2000/svg' width='13.783' height='8' viewBox='0 0 13.783 8'><path id='down_arrow' data-name='down arrow' d='M32.843,44.579a1.076,1.076,0,0,0,1.529,0L40.2,38.747a1.082,1.082,0,0,0-1.53-1.53l-5.067,5.036-5.036-5.036a1.036,1.036,0,0,0-.764-.319.988.988,0,0,0-.765.319,1.1,1.1,0,0,0,0,1.53Z' transform='translate(-26.732 -36.898)' fill='%23fff'/></svg>");
            background-size:contain;
            background-repeat:no-repeat;
            transition:transform var(--transition) ease;
            transform-origin:center;
        }

        button:has(~.open)::after{
            transform:translateY(-50%) rotate(180deg);
        }

        .widget-container {
            position: relative;
            flex-wrap: wrap;
            margin: 1rem;
            padding: 1rem;
            border: 1px solid white;
        }
        #menu{
            display:flex;
            padding:0;
            list-style:none;
            margin:0;
            flex-direction:column;
            gap:1rem;
            flex-basis:100%;
            font-family:var(--allin-font-family,inherit);
        }

        #menu li{
            margin:0;
            padding:0;
            font-size:var(--allin-menu-fontsize,0.9rem);
        }
        
        p{
            color:var(--allin-text-color,#fff);
            margin:0;
            font-family:var(--allin-font-family,inherit);
            font-size:1.5rem;
        }

        @media (min-width: 1200px){
            button{
                display:block;
                padding: 0 1.5rem 0 0;
            }
            .mobile_only{
                display:none;
            }
            #menu{
                display:none;
                position:absolute;
                top: calc(100% + 1rem);
                left:50%;
                transform:translateX(-50%);
                width:100%;
                min-width:max-content;
                background-color:var(--allin-menu-bg,#fff);
                box-shadow:var(--allin-menu-dropshadow,0 3px 6px rgba(0,0,0,0.2));
                z-index:1;
                padding:1rem 1.5rem;
                box-sizing: border-box;
            }
            #menu.open{
                display:flex;
            }
            .widget-container {
                margin:0;
                padding:0;
                border:none;
            }
        }   
    `
    ];
}
